export class ViewModelProcessoWebModulosTextos {
    idSeq: number;
    idPlano: number;
    nmPlano: string;
    idInstitutos: number;
    nmInstitutos: string;
    idModulos: number;
    nmModulos: string;
    nmTexto: string;
}